import { TreeViewItem } from "@trimbleinc/modus-react-bootstrap"
import React from "react"
import { FeatureType } from "../../../../api/types"
import featureTypeIcon from "../../Assets/Icons/featureType.svg";
import "./FeatureType.scss"

const FeatureTypeTreeItem = (props: { featureType: FeatureType; onClick: (data: any) => void }) => {

  const onclick = () => {
    props.onClick(props.featureType)
  }

  const label = (
    <div className="pr-3">
      <img src={featureTypeIcon} />
      <span className="nameString" >{props.featureType.name} </span>
      <span className="badge badge-sm badge-text-secondary">{props.featureType.id}</span>
    </div>
  )

  return <TreeViewItem nodeId={props.featureType.id*(-1)} label={label} className="card-text-2" onFocus={onclick} />
}

export default FeatureTypeTreeItem
